import type { Campaign } from '@gyym/sdk'
import { Typography } from '@gyym/ui'
import dayjs from 'dayjs'

import { CampaignDialogBodyBackground } from './styles'

export const CampaignDialogBody = ({ campaign }: { campaign: Campaign }) => (
  <div className="flex flex-col gap-1">
    <CampaignDialogBodyBackground>
      <Typography variant="body2" color="gray.02">
        {campaign.title}
      </Typography>
      <div className="flex gap-4">
        <Typography variant="subhead1" color="gray.02">
          取得ポイント
        </Typography>
        <Typography variant="subhead1" color="gray.02">
          {campaign.point}pt
        </Typography>
      </div>
      <div className="flex">
        期間 {dayjs(campaign.startAt).format('YYYY/MM/DD')} ~{' '}
        {dayjs(campaign.endAt).format('YYYY/MM/DD')}
      </div>
    </CampaignDialogBodyBackground>

    <Typography variant="body2" color="gray.01">
      ※ 他キャンペーンとの併用不可
    </Typography>
  </div>
)
